import React from 'react';

class Footer extends React.Component {
    render() {
       return (
          <div className="stuffFooter-container">
            <div className="stuffFooter-container__stuff--lightbluecolorcolorbar"></div>
            <div className="stuffFooter-container__stuff--darkgreycolorcolorbar"></div>
          </div>
       );
    }
}

export default Footer;